module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/location_type_studio_3column@2x-665ab18656f9124d3b36c7cb479d5c97.webp";